import { logRttApiCall } from './cabsAPIs';
import { API_STATUS } from './constants/errors';
// import { isSSR } from './utils/commonUtils';

export const logRttPhoneNumberErrorRequestBuilder = async (
  phoneNumber: string
) => {
  const request = {
    endPoint: '/v1/assistedFlow/formSubmit',
    rtt: 0,
    status: API_STATUS.FAILURE,
    httpStatus: 400,
    failureMessage: `Phone number validation failed for phone number: ${phoneNumber}`,
    error: 'PHONE_NUMBER_VALIDATION_FAILED'
  };

  await logRttApiCall(request);
};

export const logRttEventLogger = async ({
  eventName,
  omniUrlArgs,
  pageUrl
}) => {
  try {
    const request = {
      endPoint: `${eventName}||${omniUrlArgs}||${pageUrl}`,
      rtt: 0,
      status: API_STATUS.SUCCESS,
      httpStatus: 200,
      successMessage: `Event logged successfully`
    };
    await logRttApiCall(request);
    // .then(()=>{
    //   console.log('RTT event logged successfully');
    // }).catch((error) => {
    //   console.error('Error logging RTT event:', error);
    // });
  } catch (error) {
    console.error('Error logging RTT event:', error);
  }
};
